import { object, string, boolean } from "yup";

export const tenantSchema = object({
    name: string().required(),
    subdomain: string().required(),
    features: object({
        credits: boolean(),
        ai: boolean(),
        jobs: boolean(),
        preferencesWizard: boolean(),
        userJobs: boolean(),
    }),
    images: object({
        primaryLogo: string().url(),
        mobileLogo: string().url(),
        favIcon: string().url(),
        footerLogo: string().url(),
    }).required(),
});
